import React from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
    return (
        <nav style={{ padding: "1em", backgroundColor: "#282c34" }}>
            <Link to="/" style={{ marginRight: "20px", color: "white", textDecoration: "none" }}>Home</Link>
        </nav>
    );
};

export default Navbar;
